import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

export interface ConsolidationListParams {
    StartDate: string;
    EndDate: string;
}

export interface ExportSummaryDetailsParams {
    summaryItemId: number;
}

export interface FetchOrderSummaryDetailParams {
    orderNumber: string;
}

const GetConsolidationList = (params: ConsolidationListParams): Promise<any> =>
    request({
        url: ApiURL.Query.GetConsolidationList,
        method: RequestType.GET,
        params,
    });

const ExportSummaryDetails = (data: ExportSummaryDetailsParams): Promise<any> =>
    request({
        url: ApiURL.Query.ExportSummaryDetails,
        method: RequestType.POST,
        data,
        responseType: 'blob',
        skipBlobAutoOpen: true,
    });

const FetchOrderSummaryDetail = (data: FetchOrderSummaryDetailParams): Promise<any> =>
    request({
        url: ApiURL.Query.FetchOrderSummaryDetail,
        method: RequestType.POST,
        data,
    });

const SummaryAggregationQuery = {
    GetConsolidationList,
    ExportSummaryDetails,
    FetchOrderSummaryDetail,
};

export default SummaryAggregationQuery;
